"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var updateEntities = exports.updateEntities = function updateEntities(update, entities, transformed) {
    // If update is not supplied, then no change to entities will be made

    return Object.keys(update || {}).reduce(function (accum, key) {
        accum[key] = update[key]((entities || {})[key], (transformed || {})[key]);

        return accum;
    }, {});
};

var optimisticUpdateEntities = exports.optimisticUpdateEntities = function optimisticUpdateEntities(optimisticUpdate, entities) {
    return Object.keys(optimisticUpdate).reduce(function (accum, key) {
        accum[key] = optimisticUpdate[key](entities[key]);

        return accum;
    }, {});
};

var rollbackEntities = exports.rollbackEntities = function rollbackEntities() {
    var rollback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var initialEntities = arguments[1];
    var entities = arguments[2];

    return Object.keys(initialEntities).reduce(function (accum, key) {
        if (rollback[key]) {
            accum[key] = rollback[key](initialEntities[key], entities[key]);
        } else {
            // Default to just reverting to the initial state for that
            // entity (before the optimistic update)
            accum[key] = initialEntities[key];
        }

        return accum;
    }, {});
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/lib/update.js
 ** module id = 315
 ** module chunks = 3
 **/